<template>
	<!--	style="
			display:inline-block;
			line-height: 0;
		"-->
	<span
		:id="idHjalpknapp"
		class="_eui-hjalpknapp"
		:class="{ '-osynlig':vpOsynlig }"
		:disabled="vpInaktiverad"
	>
		<!--@tryckt="onKnappTryckt('avbryt')"-->
		<eui-knapp
			:id="idHjalpknappKnapp"
			:disabled="vpInaktiverad"
			:vp-tooltip="vpTooltip"
			vp-css-modifier-class="-transparent"
			style="
				display: inline-flex;
				width: 100%;
				height: 100%;
				padding: .12em;
			"
			:style="{ color:vpColor }"
		>
			<eui-modifierad-svg
				vp-ikon="hjalpknapp"
				style="
					stroke-width: 1.4;
				"
			></eui-modifierad-svg>

		</eui-knapp>

		<!-- The button element has a default type of submit. You can make it do nothing by setting a type of button: -->
		<!--<button type="button"
			:id="idHjalpknappKnapp"
			:disabled="vpInaktiverad"
			:style="styleKnapp"
			style="
				display:inline-block;
				width:1.1em;
				height:1.1em;
				line-height:0;
				border:none;
				background:none;
				margin:0;
				padding:0;
				vertical-align:-.05em;
				cursor:pointer;
				overflow:hidden;
			"
		>
			<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px" y="0px" xml:space="preserve"
				viewBox="0 0 170 170"
				:style="{ stroke:color }"
				style="overflow:visible;
					stroke-linecap:round;
					stroke-linejoin:round;
					stroke-miterlimit:10;
					fill:none;
					stroke-width:13;
					width:75%;
					height:75%;">
				<g id="Cirkel-fragetecken-01">
					<g>
						<circle id="cirkel" cx="85" cy="85" r="80"></circle>
						<g id="fragetecken">
							<g id="punkt">
								<circle id="punkt-2" cx="85" cy="124.5" r="0.5"></circle>
								<circle id="punkt-3" cx="85" cy="124.5" r="1.5"></circle>
								<circle id="punkt-4" cx="85" cy="124.5" r="2.45"></circle>
							</g>
							<path id="boj" d="M60,58.54c4.81-13.68,21-20.54,33.47-16C103.91,46.25,111,54.57,111,67.28,111,85,84.76,95.53,84.76,95.53"></path>
						</g>
					</g>
				</g>
			</svg>

		</button>-->

		<div :id="idHjalpknappText"
			class="_eui-hjalpknapp-text mindre"
			style="display:none;"
		>
			<slot>
				Hjälpknapp-text saknas :(
			</slot>
		</div>

	</span>
</template>


//#####################################################################################

<script>
	import tippy from 'tippy.js';
	import { ssoTooltips } from 'ssoTooltips';
	import euiKnapp from 'v-components/euiKnapp';
	import euiModifieradSvg from 'v-components/euiModifieradSvg';

	export default {

		name: 'eui-hjalpknapp',

		components: {
			euiKnapp,
			euiModifieradSvg,
		},

		props:
		{
			// Todo: Borde ist vara vpCssModifierClass, se andra ställen:
			vpColor: {
				type: String,
				default: 'rgb(0, 136, 221)',
			},
			vpUniktIdDel: {
				type: String,
				default: '1',
			},

			vpTooltip: {
				type: String,			// Får innehålla HTML.
				default: null
			},
			//styleKnapp: {
			//	type: Object,
			//	default() {},
			//},

			vpInaktiverad: {
				type: Boolean,
				default: false,
			},
			vpOsynlig: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {
				hjalptipset: null,	// Initialt så. null betyder 'ännu inte satt'
			};
		},

		computed: {
			idHjalpknapp() {
				return `hjalpknapp-${this.vpUniktIdDel}`;
			},
			idHjalpknappKnapp() {
				return `hjalpknapp-knapp-${this.vpUniktIdDel}`;
			},
			idHjalpknappText() {
				return `hjalpknapp-text-${this.vpUniktIdDel}`;
			},
		},


		//== Lifecycle hooks  ================================================================================================================

		beforeCreate()
		{
			//let x = 0;	// Todo: TMP!!
		},

		mounted() {

			this.$nextTick(function ()
			{
				// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
				// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

				// Merging objects with same properties (sista argumentet har högst "prio", se https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Merging_objects_with_same_properties):
				const options = Object.assign(
					{},	// Till  ett *nytt* object!
					ssoTooltips.tippyOptionsHjalpknapp,	// Skriv först över med detta...
					{	// ...sen detta:

						// Endast de som avviker från standard hjalptips (tippyOptionsHjalpknapp) + den som måste sättas individuellt för varje hjälpknapp (html):

						// Specifies that the tooltip should have HTML content injected into it.
						// A selector string indicates that a template should be cloned, whereas
						// a DOM element indicates it should be directly appended to the tooltip
						html: document.querySelector(`#${this.idHjalpknappText}`),
					}
				);

				// Har varit 'none'. Hinner inte synas innan tippy.one nedan knycker den så den försvinner:
				options.html.style.display = 'block';

				this.hjalptipset = tippy.one(`#${this.idHjalpknappKnapp}`, options);
			});
		},

	}
</script>
